<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl relative">
        Raporty
    </h1>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nazwa</th>
          <th class="px-6 pt-6 pb-4">Odbiorcy</th>
          <th class="px-6 pt-6 pb-4">Cykl</th>
          <th class="px-6 pt-6 pb-4">Dzień</th>
          <th class="px-6 pt-6 pb-4">Godzina</th>
          <th class="px-6 pt-6 pb-4">Zależny</th>
          <th class="px-6 pt-6 pb-4">Aktywny</th>
        </tr>
        <tr v-for="report in reports" :key="report.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('reports.edit', report.id)">
              {{ report.name }}
            </inertia-link>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
                <template v-for="user in report.users">
                    <span class="px-3 py-1 bg-shtax-500 rounded-lg text-white text-sm mr-1">{{ user.first_name +' '+ user.last_name }}</span> 
                </template>
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ report.period }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ report.day_of_month }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ report.hour_of_day }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ report.is_dependent ? 'Tak' : 'Nie' }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-6 py-4 flex items-center focus:text-shtax-500">
              {{ report.deleted_at ? 'Nie' : 'Tak' }}
            </span>
          </td>
        </tr>
        <tr v-if="reports.length === 0">
          <td class="border-t px-6 py-4" colspan="7">Brak zdefiniowanych raportów.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
  metaInfo: { title: 'Raporty' },
  layout: Layout,
  components: {
  },
  layout: Layout,
  props: {
    reports: Array
  },
  data() {
    return {
    }
  }
}
</script>
